import { GenericValueLabelType } from '@doc-abode/data-models';
import { findByValue } from './findByValue';

export function getFriendlyLabel(
    typeToExtractFrom?: GenericValueLabelType,
    textIfNotFound?: string,
): string {
    if (!typeToExtractFrom) {
        return textIfNotFound ?? '';
    }

    return typeToExtractFrom.label;
}

export function getFriendlyLabelFromArray(
    valueToFind?: string,
    arrayToSearch?: GenericValueLabelType[],
    textIfNotFound?: string,
): string {
    const fallback = textIfNotFound ?? '';

    // If no to-be looked for value has been passed, return the fallback value or empty string
    if (!valueToFind) {
        return fallback;
    }

    // If there is no array to look through, return the to-be looked for value as-is
    if (!arrayToSearch) {
        return fallback;
    }

    const genericValueType = findByValue(valueToFind, arrayToSearch);

    return getFriendlyLabel(genericValueType, fallback);
}
